import { axios } from "@/lib/axios";

import { TAppointmentSlotInitialValues } from "../../containers/Muqabalas/AppointmentSlots/AppointmentSlots.container";
import {
  IAPIGetAppointmentSlots,
  IAPIGetAppointmentSlot,
  IAPIPostAppointmentSlot,
  IAPIPatchAppointmentSlot,
  IAPIDeleteAppointmentSlot,
} from "../../types/interfaces/api/appointmentSlots";

export const getAppointmentSlots = (
  date: string
): Promise<IAPIGetAppointmentSlots> => {
  return axios.get(`/muqabala/appointment-slots/available-for-admins`, {
    params: {
      date,
    },
  });
};

export const getAppointmentSlot = (
  id: string
): Promise<IAPIGetAppointmentSlot> => {
  return axios.get(`/muqabala/appointment-slots/${id}`);
};

export const createAppointmentSlot = (
  datas: TAppointmentSlotInitialValues
): Promise<IAPIPostAppointmentSlot> => {
  return axios.post("/muqabala/appointment-slots", {
    ...datas,
  });
};

export const editAppointmentSlot = (
  id: string,
  datas: Partial<TAppointmentSlotInitialValues>
): Promise<IAPIPatchAppointmentSlot> => {
  return axios.patch(`/muqabala/appointment-slots/${id}`, {
    ...datas,
  });
};

export const deleteAppointmentSlot = (
  id: string
): Promise<IAPIDeleteAppointmentSlot> => {
  return axios.delete(`/muqabala/appointment-slots/${id}`);
};
